import axios from "axios"
//import {browserHistory} from 'react-router';

// const
const REDIRECT_TO_APPLICATION_MARKET_PORTAL = "applicationMarketPortal/REDIRECT_TO_APPLICATION_MARKET_PORTAL";
const APPLICATION_MARKET_PORTAL_STORE_APPLICATIONS = "applicationMarketPortal/APPLICATION_MARKET_PORTAL_STORE_APPLICATIONS";
const APPLICATION_MARKET_PORTAL_STORE_TOP_APPLICATIONS = "applicationMarketPortal/APPLICATION_MARKET_PORTAL_STORE_TOP_APPLICATIONS";
const APPLICATION_MARKET_PORTAL_STORE_ALGORITHMS = "applicationMarketPortal/APPLICATION_MARKET_PORTAL_STORE_ALGORITHMS";
const APPLICATION_MARKET_PORTAL_STORE_CATEGORY_APPLICATIONS = "applicationMarketPortal/APPLICATION_MARKET_PORTAL_STORE_CATEGORY_APPLICATIONS";
const APPLICATION_MARKET_PORTAL_STORE_APPLICATION_CATEGORIES = "applicationMarketPortal/APPLICATION_MARKET_PORTAL_STORE_APPLICATION_CATEGORIES";
const APPLICATION_MARKET_PORTAL_UPDATE_DATA = "applicationMarketPortal/APPLICATION_MARKET_PORTAL_UPDATE_DATA";
const APPLICATION_MARKET_PORTAL_TOGGLE_LOADING = "applicationMarketPortal/APPLICATION_MARKET_PORTAL_TOGGLE_LOADING";

// reducer
export const applicationMarketPortal = (state = {
  loading: false,

  applications: [],
  topApplications: [],
  categoryApplications: [],
  applicationCategories: [],
  algorithms: [],
  name: "",

}, action) => {
  switch (action.type) {
    case APPLICATION_MARKET_PORTAL_STORE_APPLICATIONS:
      return {
        ...state,
        applications: action.data
      };
    case APPLICATION_MARKET_PORTAL_STORE_TOP_APPLICATIONS:
      return {
        ...state,
        topApplications: action.data
      };
    case APPLICATION_MARKET_PORTAL_STORE_ALGORITHMS:
      return {
        ...state,
        algorithms: action.data
      };
    case APPLICATION_MARKET_PORTAL_STORE_CATEGORY_APPLICATIONS:
      return {
        ...state,
        categoryApplications: action.data
      };
    case APPLICATION_MARKET_PORTAL_STORE_APPLICATION_CATEGORIES:
      return {
        ...state,
        applicationCategories: action.data
      };
    case APPLICATION_MARKET_PORTAL_UPDATE_DATA:
      return {
        ...state,
        [action.data.name]: action.data.value
      };
    case APPLICATION_MARKET_PORTAL_TOGGLE_LOADING:
      return {
        ...state,
        loading: action.data
      };
    default:
      return state
  }
};

/**
 * get all applications
 */
export const getApplications = () => (dispatch) => {
  dispatch(toggleLoading(true));

  axios.get("/api-application/applications", {contentType: "application/json"}).then(
    response => {
      if (response.data) {
        dispatch(storeApplications(response.data._embedded.applications));
        dispatch(toggleLoading(false));
      }
    }
  );
};

/**
 * store all applications
 */
export const storeApplications = (applications) => {
  return {
    type: APPLICATION_MARKET_PORTAL_STORE_APPLICATIONS,
    data: applications
  }
};

/**
 * get top applications
 */
export const getTopApplications = () => (dispatch) => {
  dispatch(toggleLoading(true));

  axios.get("/api-application/getTopApplication", {contentType: "application/json"}).then(
    response => {
      if (response.data) {
        dispatch(storeTopApplications(response.data));
        dispatch(toggleLoading(false));
      }
    }
  );
};

/**
 * store top applications
 */
export const storeTopApplications = (topApplications) => {
  return {
    type: APPLICATION_MARKET_PORTAL_STORE_TOP_APPLICATIONS,
    data: topApplications
  }
};

/**
 * get algorithms
 */
export const getAlgorithms = () => (dispatch) => {
  dispatch(toggleLoading(true));

  axios.get("/api-algorithm/getTopAlgorithms", {contentType: "application/json"}).then(
    response => {
      if (response.data) {
        dispatch(storeAlgorithms(response.data.content));
        dispatch(toggleLoading(false));
      }
    }
  );
};

/**
 * store algorithms
 */
export const storeAlgorithms = (algorithms) => {
  return {
    type: APPLICATION_MARKET_PORTAL_STORE_ALGORITHMS,
    data: algorithms
  }
};

/**
 * get category applications
 */
export const getCategoryApplications = () => (dispatch) => {
  dispatch(toggleLoading(true));

  axios.get("/api-application/getCategoryApplication", {contentType: "application/json"}).then(
    response => {
      if (response.data) {
        dispatch(storeCategoryApplications(response.data));
        dispatch(toggleLoading(false));
      }
    }
  );
};

/**
 * store category applications
 */
export const storeCategoryApplications = (categoryApplications) => {
  return {
    type: APPLICATION_MARKET_PORTAL_STORE_CATEGORY_APPLICATIONS,
    data: categoryApplications
  }
};

/**
 * get all application categories
 */
export const getApplicationCategories = () => (dispatch) => {
  dispatch(toggleLoading(true));

  axios.get("/api-application/applicationCategories", {contentType: "application/json"}).then(
    response => {
      if (response.data) {
        dispatch(storeApplicationCategories(response.data._embedded.applicationCategories));
        dispatch(toggleLoading(false));
      }
    }
  );
};

/**
 * store all application categories
 */
export const storeApplicationCategories = (applicationCategories) => {
  return {
    type: APPLICATION_MARKET_PORTAL_STORE_APPLICATION_CATEGORIES,
    data: applicationCategories
  }
};

/**
 * update data based on user input
 */
export const updateApplicationMarketPortalData = (data) => {
  return {
    type: APPLICATION_MARKET_PORTAL_UPDATE_DATA,
    data: data
  }
};

/**
 * toggle loading
 */
export const toggleLoading = (show) => {
  return {
    type: APPLICATION_MARKET_PORTAL_TOGGLE_LOADING,
    data: show
  }
};
